import {useEffect, useState} from "react";
import {NavSnipes} from "../../NavSnipes";
import styled from "styled-components";
import FeedEntry from "./FeedEntry";

const Container = styled.div`
    color: white;
    font-family: 'Inter', sans-serif;
    text-align: center;
    max-width: 800px;
    margin: 0 auto;
    
    h2 {
        text-transform: uppercase;
        color: #d2a83a;
        font-size: 32pt;
    }

    @media screen and (min-width: 800px) {
    }
`;

export default function KillFeed() {
    const [killfeed, setKillfeed] = useState([]);

    useEffect(() => {
        NavSnipes.getKillfeed(20).then(setKillfeed);
    }, [setKillfeed]);

    return (
        <Container>
            <h2>
                Kill Feed
            </h2>
            {killfeed.map((entry) => (
                <FeedEntry key={entry.ID} id={entry.ID} executor={entry.Executor} executed={entry.Executed} time={entry.Time} />
            ))}
        </Container>
    )
}